import { render, staticRenderFns } from "./SurgeryCategorySelect.vue?vue&type=template&id=df2e68c2"
import script from "./SurgeryCategorySelect.vue?vue&type=script&lang=js"
export * from "./SurgeryCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports